export default {
  marketOptions: ({ outcomesPerEvent }) => ({ boosted: true, outcomesPerEvent }),
  cardBodyClassNames: () => 'bet-boost-market',
};
